import React, { useState } from "react";
import { Tabs, Table, Modal, Row, Typography } from "antd";
import { TabText } from "../../../shared/globalStyling/styledText";
import { kmToFt } from "../../../../core/utils/campaigns";
import { isEmpty } from "lodash";
import { InfoCircleTwoTone } from "@ant-design/icons";

const { Text } = Typography;

const style = {
  tableHeaderStyle: {
    color: "rgb(144, 142, 142)",
    fontWeight: 0,
    fontSize: "0.8em",
  },
  title: {
    marginBottom: "10px",
    fontWeight: "bold",
    fontSize: "1em",
  },
};

const GeotargetStates = ({ geoTargets, attributionTargets }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const showModal = () => {
  //   setIsModalOpen(true);
  // };
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  let columns = [
    {
      title: () => <div style={style.tableHeaderStyle}>State Name</div>,
      width: 5,
      dataIndex: "state",
      key: "state",
    },
    {
      title: () => <div style={style.tableHeaderStyle}>Locations</div>,
      width: 5,
      dataIndex: "location",
      key: "location",
    },
    {
      title: () => <div style={style.tableHeaderStyle}>Average Radius</div>,
      width: 5,
      dataIndex: "",
      key: "",
      render: record => {
        const averageRadius = Number(record.radius) / Number(record.location);
        return <div>{averageRadius.toFixed()}</div>;
      },
    },
    {
      title: () => (
        <div style={style.tableHeaderStyle}>Total Area Capture (Meters)</div>
      ),
      width: 5,
      dataIndex: "radius",
      key: "radius",
    },
    // {
    //   title: () => <div style={style.tableHeaderStyle}>Option</div>,
    //   width: 5,
    //   dataIndex: "",
    //   key: "",
    //   // render: button => {
    //   //   return (
    //   //     // <Button type="primary" onClick={showModal}>
    //   //     //   View Rules
    //   //     // </Button>
    //   //   );
    //   // },
    // },
  ];

  let stateArr = [];
  let attributionArr = [];

  attributionTargets &&
    attributionTargets.forEach(attri => {
      attri &&
        attri.circles.forEach(circ => {
          const circleState = circ && circ.location && circ.location.state;
          const circleRadius = circ && circ.radius;
          const radius = Math.round(kmToFt(circleRadius));

          attributionArr.push({
            state: circleState,
            radius: radius,
            location: 1,
          });
        });
    });

  geoTargets &&
    geoTargets.forEach(geo => {
      geo &&
        geo.circles.forEach(circ => {
          const circleState = circ && circ.location && circ.location.state;
          const circleRadius = circ && circ.radius;
          const radius = Math.round(kmToFt(circleRadius));

          stateArr.push({ state: circleState, radius: radius, location: 1 });
        });
    });

  const resultTable =
    !isEmpty(stateArr) &&
    stateArr.reduce((acc, item) => {
      const existingItem = acc.find(i => i.state === item.state);
      if (existingItem) {
        existingItem.radius += item.radius;
        existingItem.location += item.location;
      } else {
        acc.push({
          state: item.state,
          radius: item.radius,
          location: item.location,
        });
      }
      return acc;
    }, []);

  return (
    <>
      <Modal
        title={
          <>
            <InfoCircleTwoTone />{" "}
            <Text type="primary" style={style.title}>
              State Rules
            </Text>
          </>
        }
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        <Row>
          <p>
            <b>
              Here is a general overview of the legal status and compliance
              rules for cannabis in some of the states where it is legal:
            </b>
          </p>
          <p>
            California: Cannabis is legal for both medical and recreational use
            in California. The state has a regulatory agency, the Bureau of
            Cannabis Control, that oversees compliance with rules regarding
            cultivation, distribution, and sales.
          </p>
          <p>
            Colorado: Cannabis is legal for both medical and recreational use in
            Colorado. The state has a regulatory agency, the Colorado Marijuana
            Enforcement Division, that oversees compliance with rules regarding
            cultivation, distribution, and sales.
          </p>
          <p>
            Oregon: Cannabis is legal for both medical and recreational use in
            Oregon. The state has a regulatory agency, the Oregon Liquor Control
            Commission, that oversees compliance with rules regarding
            cultivation, distribution, and sales.
          </p>
          <p>
            Washington: Cannabis is legal for both medical and recreational use
            in Washington. The state has a regulatory agency, the Washington
            State Liquor and Cannabis Board, that oversees compliance with rules
            regarding cultivation, distribution, and sales.
          </p>
          <p>
            Massachusetts: Cannabis is legal for both medical and recreational
            use in Massachusetts. The state has a regulatory agency, the
            Cannabis Control Commission, that oversees compliance with rules
            regarding cultivation, distribution, and sales.
          </p>
        </Row>
      </Modal>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab={<TabText text={"GeoTarget"} />} key="1">
          <Table
            dataSource={resultTable}
            columns={columns}
            bordered
            pagination={false}
            style={{ minWidth: "500px" }}
          />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

export default GeotargetStates;
